export const sizes = {
  smallerScreen: 1100,
  largerScreen: 1920,
  mobile: 1024,
  smallWidthImgCarousel: 700,
};

export const device = {
  small: `@media (max-width: ${sizes.smallerScreen}px)`,
  large: `@media (min-width: ${sizes.smallerScreen}px)`,
  mobile: `@media (max-width: ${sizes.mobile}px)`,
};
